'use client';

import { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import CategoryActionCard from '../../CategoryActionCard/CategoryActionCard';
import { Category } from '@repo/common/interfaces';

import { VpIcon, VpIconButton } from '@vtmn-play/react';

import '../WidgetServiceCategoryItem.scss';

interface WidgetCategoryItemProps {
  onClick: () => void;
  category: Category<string>;
}

const paragraphChunksNode = (chunks: ReactNode) => {
  return <p>{chunks}</p>;
};

const WidgetCategoryItem = ({ onClick, category }: WidgetCategoryItemProps) => {
  const t = useTranslations('Widget.pages.steps.categories.content.card');
  const tCategoryCard = useTranslations('Generic.category');

  return (
    <CategoryActionCard
      action={
        <VpIconButton
          className='widget-category-item-selection'
          onClick={onClick}
          size='small'
          type='button'
          variant='tertiary'
        >
          <VpIcon className='rtl-swap' name='chevron-right' size={20} />
          <span className='sr-only'>{t('buttons.select')}</span>
        </VpIconButton>
      }
      categoryType={category?.type}
      className='widget-category-item'
      description={
        tCategoryCard.has(`${category?.type?.toLowerCase()}.description`) && (
          <div className='flex flex-col gap-1'>
            {tCategoryCard.rich(
              `${category?.type?.toLowerCase()}.description`,
              { paragraph: paragraphChunksNode },
            )}
          </div>
        )
      }
      i18n={{
        showDescription: tCategoryCard('card.details'),
        serviceCountChip: category?.items?.length
          ? tCategoryCard('serviceCountChip', {
              serviceCount: category?.items?.length,
            })
          : undefined,
      }}
      id={category.type}
      name={tCategoryCard(`${category?.type?.toLowerCase()}.title`)}
      subtitle={tCategoryCard(`${category?.type?.toLowerCase()}.subtitle`)}
    />
  );
};

export default WidgetCategoryItem;
